// CombinedHero.tsx
import React from 'react';
import { Button } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.css';

function CombinedHero() {
  const navigate = useNavigate();

  return (
    <div className={styles.combinedHero}>
      <div className={styles.heroSection}>
        <h1 className={styles.heroTitle}>
          Transactional Counsel for Businesses, Entrepreneurs & Investors
        </h1>
        <p className={styles.heroSubtitle}>
          Trusted legal advisors for commercial transactions, corporate deals,
          and cross-border business operations.
        </p>
        <Button
          type="primary"
          size="large"
          className={styles.primaryButton}
          icon={<PhoneOutlined />}
          onClick={() => navigate('/contact')}
        >
          Schedule a Consultation
        </Button>
      </div>
    </div>
  );
}

export default CombinedHero;
